export default __webpack_public_path__ + "static/media/Reports-2x.ccd179eb.png";